import { Theme, ThemeName } from '@/types/theme';
import BrandliveLogo from './brandlive-old/brandlive-logo';
import BrandliveOldBackdrop from './brandlive-old/brandlive-old-backdrop/brandlive-backdrop';

const brandlive: Theme = {
  name: ThemeName.BRANDLIVE_OLD,
  backdrop: {
    component: BrandliveOldBackdrop,
  },
  logo: BrandliveLogo,
};

export default brandlive;
